import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Subtitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  padding: 12px 0;
`;

export const GroupTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  padding: 12px 0px 0px 12px;
`;

export const Item = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 46px;
  padding: 4px 16px;
  border-radius: 4px;

  :hover {
    background-color: ${(props) => props.theme.color.blue.glassShade};
  }

  ${mediaQuery('small')} {
    gap: 6px;
    margin-bottom: 12px;
  }
`;

export const PLabel = styled.div<{ padded?: string }>`
  font-weight: 500;
  display: inline-block;

  ${(props) => props.padded && 'padding-left: 20px;'}

  ${mediaQuery('small')} {
    padding-left: 0px;
    max-width: 45%;
  }
`;
